(function () {
  'use strict';
  if (!window.LDO_FITMENT_V5 || !window.LDO_FITMENT_V5.products) return;

  var products = window.LDO_FITMENT_V5.products;

  function gm1500Rows(start, end, req) {
    return [
      [start, end, 'Chevrolet', 'Silverado 1500', 'M', req],
      [start, end, 'GMC', 'Sierra 1500', 'M', req]
    ];
  }

  // ReadyLIFT 69-3414: 2014-2018 GM 1500, 2WD/4WD, factory Aluminum or Stamped Steel UCA only.
  var rl3414 = products['readylift-4-sst-lift-kit-2014-2018-silverado-sierra-1500-2wd-4wd-w-cast-alum-or-stamped-steel-uca-69-3414'];
  if (rl3414) {
    rl3414.f = gm1500Rows(2014, 2018, {
      drive: ['2WD', '4WD'],
      suspension: ['Aluminum', 'Stamped Steel']
    });
    rl3414.r = {};
    rl3414.x = ['2WD', '4WD', 'Aluminum', 'Stamped Steel'];
    rl3414.z = [
      'Factory Aluminum or Stamped Steel upper control arms only; not for Cast Steel suspension',
      'Not for AWD Denali; Single Cab fitment/drivability has not been validated by ReadyLIFT'
    ];
  }

  function apply3416(record) {
    if (!record) return;
    record.f = []
      .concat(gm1500Rows(2014, 2016, {
        drive: ['2WD', '4WD'],
        suspension: ['Cast Steel']
      }))
      .concat(gm1500Rows(2017, 2018, {
        drive: ['2WD'],
        suspension: ['Cast Steel']
      }));
    record.r = {};
    record.x = ['Cast Steel', '2WD', '4WD'];
    record.z = [
      'Cast Steel upper control arms only; 2017-2018 application is 2WD only',
      'Not for AWD Denali; Single Cab fitment/drivability has not been validated by ReadyLIFT'
    ];
  }

  // ReadyLIFT 69-3416 current live handle.
  apply3416(products['readylift-4-sst-lift-kit-2014-2018-silverado-sierra-1500-2wd-4wd-w-cast-steel-uca-69-3416']);

  // Legacy duplicate handle in the fitment snapshot also identifies itself as 69-3416.
  // Keep its rules equally strict so it cannot surface as a false 2017-2018 4WD match.
  apply3416(products['readylift-sst-lift-kit-4-0in-front-1-75in-rear-w-a-arm-kit-2007-2013-gm-chevy-1500-4wd']);
})();
